"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _course = require("../../store/course");
var _materialEx = require("../../components/material-ex");
var _Style = require("../../style/Style");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [location, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    courses,
    errors,
    fetchCourses,
    deleteCourse
  } = (0, _course.useCourseStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchCourses();
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30B3\u30FC\u30B9\u7BA1\u7406"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
        ...stylex.props(_Style.buttonStyle.primary),
        onClick: () => {
          setLocation('/course/add');
        },
        children: "\u65B0\u3057\u3044\u30B3\u30FC\u30B9\u3092\u8FFD\u52A0"
      })]
    }), courses.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
        sx: {
          tableLayout: 'fixed'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30B3\u30FC\u30B9\u540D"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30AB\u30C6\u30B4\u30EA"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30B5\u30E0\u30CD\u30A4\u30EB"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {})]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableBody, {
          children: courses.map(course => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: course.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: course.detail
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                isCenter: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  ...stylex.props(_Style.imageStyle.courseList),
                  src: course.thumbnailPreviewUrl,
                  alt: course.name
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                isCenter: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
                  spacing: 2,
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/course/detail/' + course.id);
                    },
                    children: "\u8A73\u7D30\u3068\u6559\u6750\u4E00\u89A7"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/course/edit/' + course.id);
                    },
                    children: "\u30B3\u30FC\u30B9\u60C5\u5831\u3092\u7DE8\u96C6"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: async () => {
                      if (!window.confirm('コース「' + course.name + '」を削除してもよろしいですか？')) return;
                      setIsLoading(true);
                      const deleteResult = await deleteCourse(course.id);
                      setIsLoading(false);
                      if (!deleteResult) {
                        setToastText('削除中にエラーが発生しました');
                        setToastOpen(true);
                        return;
                      }
                      setToastText('コース「' + course.name + '」を削除しました');
                      setToastOpen(true);
                    },
                    children: "\u30B3\u30FC\u30B9\u60C5\u5831\u3092\u524A\u9664"
                  })]
                })
              })]
            });
          })
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.p1b),
      children: errors.list || '該当するコースが存在しません'
    })]
  });
};
var _default = exports.default = App;